import { type AxiosRequestConfig } from 'axios'

const getPublicConfig = (): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: '/public/config'
  }
}

export { getPublicConfig }
